import React from "react";

import CountUp from "react-countup";

import { STATS } from "@/lib/site";

export default function Stats() {

  return (
    <section

      className="
        relative

        py-24 md:py-28

        overflow-hidden

        bg-gradient-to-b
        from-white
        via-[#F8F4FB]
        to-white
      "
    >

      {/* ===================================================== */}
      {/* MOBILE KEYFRAMES */}
      {/* ===================================================== */}

      <style>
        {`
          @keyframes statsReveal {
            0% {
              opacity: 0;
              transform:
                translateY(45px)
                scale(0.94);
            }

            60% {
              opacity: 1;
              transform:
                translateY(-6px)
                scale(1.01);
            }

            100% {
              opacity: 1;
              transform:
                translateY(0)
                scale(1);
            }
          }

          @keyframes floatingCard {
            0% {
              transform: translateY(0px);
            }

            50% {
              transform: translateY(-7px);
            }

            100% {
              transform: translateY(0px);
            }
          }

          @keyframes pulseGlow {
            0% {
              opacity: 0.4;
              transform: scale(1);
            }

            50% {
              opacity: 1;
              transform: scale(1.08);
            }

            100% {
              opacity: 0.4;
              transform: scale(1);
            }
          }

          @media (max-width: 768px) {

            .stats-card {
              animation:
                statsReveal 0.9s
                cubic-bezier(0.22, 1, 0.36, 1)
                forwards;
            }

            .stats-number {
              animation:
                floatingCard 3s ease-in-out infinite;
            }

            .stats-glow {
              animation:
                pulseGlow 4s ease-in-out infinite;
            }
          }
        `}
      </style>

      {/* TOP LEFT GLOW */}

      <div
        className="
          absolute

          top-[-120px]
          left-[-120px]

          w-[420px]
          h-[420px]

          bg-purple-300/15

          rounded-full

          blur-[120px]
        "
      />

      {/* BOTTOM RIGHT GLOW */}

      <div
        className="
          absolute

          bottom-[-120px]
          right-[-120px]

          w-[420px]
          h-[420px]

          bg-fuchsia-300/12

          rounded-full

          blur-[120px]
        "
      />

      {/* GRID OVERLAY */}

      <div
        className="
          absolute inset-0

          grid-bg

          opacity-[0.03]
        "
      />

      <div
        className="
          relative

          max-w-7xl
          mx-auto

          px-6 md:px-8
        "
      >

        {/* ===================================================== */}
        {/* HEADER */}
        {/* ===================================================== */}

        <div
          className="
            text-center

            max-w-3xl

            mx-auto

            mb-14 md:mb-16
          "
        >

          <div
            className="
              text-purple-600

              uppercase

              tracking-[0.35em]

              text-sm

              font-bold

              mb-4
            "
          >

            OUR IMPACT

          </div>

          <h2
            className="
              text-4xl
              md:text-5xl

              font-bold

              text-slate-900

              leading-tight
            "
            style={{
              fontFamily: "Sora",
            }}
          >

            Trusted by growing
            <br />

            businesses worldwide

          </h2>

          <p
            className="
              mt-6

              text-lg

              text-slate-600

              leading-relaxed
            "
          >

            Delivering scalable technology,
            enterprise solutions, AI systems,
            and digital transformation with
            measurable business impact.

          </p>

        </div>

        {/* ===================================================== */}
        {/* STATS GRID */}
        {/* ===================================================== */}

        <div
          className="
            grid

            grid-cols-2
            md:grid-cols-4

            gap-5 md:gap-7
          "
        >

          {STATS.map((stat, index) => (

            <div
              key={index}

              className="
                stats-card

                group

                relative

                overflow-hidden

                rounded-[28px] md:rounded-[32px]

                border
                border-purple-100/60

                bg-white/70

                backdrop-blur-2xl

                p-6 md:p-8

                text-center

                transition-all
                duration-500

                hover:-translate-y-2

                hover:border-purple-200

                shadow-[0_12px_40px_rgba(120,70,180,0.08)]

                hover:shadow-[0_24px_70px_rgba(120,70,180,0.16)]
              "
              style={{
                animationDelay: `${index * 0.12}s`,
              }}
            >

              {/* TOP GLOW */}

              <div
                className="
                  stats-glow

                  absolute

                  top-0
                  right-0

                  w-32
                  h-32

                  bg-purple-300/15

                  rounded-full

                  blur-3xl

                  opacity-0

                  group-hover:opacity-100

                  transition-all
                  duration-500
                "
              />

              {/* BOTTOM GLOW */}

              <div
                className="
                  absolute

                  bottom-0
                  left-0

                  w-24
                  h-24

                  bg-fuchsia-300/10

                  rounded-full

                  blur-3xl

                  opacity-0

                  group-hover:opacity-100

                  transition-all
                  duration-500
                "
              />

              {/* VALUE */}

              <div
                className="
                  stats-number

                  relative

                  text-4xl md:text-5xl

                  font-bold

                  text-slate-900
                "
                style={{
                  fontFamily: "Sora",
                }}
              >

                <CountUp
                  end={stat.value}
                  duration={2.5}
                />

                <span
                  className="
                    bg-gradient-to-r
                    from-[#6D3B8C]
                    via-[#9B4D96]
                    to-[#C67BCF]

                    bg-clip-text

                    text-transparent
                  "
                >

                  {stat.suffix}

                </span>

              </div>

              {/* LABEL */}

              <div
                className="
                  mt-4

                  uppercase

                  tracking-[0.25em]

                  text-[10px] md:text-xs

                  text-slate-500

                  font-semibold

                  leading-relaxed
                "
              >

                {stat.label}

              </div>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
}